import { IRadioDropdownOption } from '../components/shared/radio-dropdown/radio-dropdown';
import { getKeyByValue } from '../utils/helpers/polls-helper';

export const ITERATE_NUMBER = 1;
export const MAX_POLLS_LIST_SIZE = 100;
export const MAX_RESPONSES_LIMIT = 20;
export const POLLS_LIST_LIMIT_MESSAGE = `<p>Poll cannot be saved because the maximum has been reached <b>(${MAX_POLLS_LIST_SIZE})</b>.</p>`;
export const POLLS_RESPONSES_LIMIT_MESSAGE = `<p>Response cannot be saved because the maximum has been reached <b>(${MAX_RESPONSES_LIMIT})</b>.</p>`;
export const LEFT_COORDINATS_SUM_PX = 25;
export const MOBILE_ELIPSIS_LEFT_CORRECTION = 107;
export const MOBILE_ELIPSIS_TOP_CORRECTION = 30;
export const MOBILE_ELIPSIS_TOP_CORRECTION_MOBILE = 20;
export const DEFAULT_STREAM_ADJUSTMENT = 30;
export const MILLI = 1000;
export const ADDITIONAL_DELTA = 100;
export const EMPTY_LIST_TEXT = 'There are no Polls.';
export const CREATE_POLL_BUTTON_TEXT = 'Create Poll';
export const NUMBER_OF_RETRIES = 10;
export const DELAY = 5000;

export enum PollsViewStatuses {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  RESETED = 'RESETED'
}

export enum PollsTypes {
  MULTIPLE_CHOICE = 'Multiple Choice',
  RATINGS = 'Ratings',
  FREEFOR_TEXT_FIELD = 'Freeform text field',
  MULTIPLE_SELECT = 'Multiple select'
}

export type TPollStatus = keyof typeof PollsViewStatuses;
export type TPollType = keyof typeof PollsTypes;

export enum PresenterVisibility {
  HIDDEN = 'Hidden from Presenter',
  VISIBLE = 'Visible to Presenter'
}

export enum ManagePollActions {
  RESPONSE_TYPE = 'response-type',
  PRESENTER_VISIBLE = 'presenter-visible'
}

export enum PollChoiceStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

export const responseTypeOptions: IRadioDropdownOption[] = [
  { id: 1, title: PollsTypes.MULTIPLE_CHOICE, disabled: false, value: PollsTypes.MULTIPLE_CHOICE },
  { id: 2, title: PollsTypes.RATINGS, disabled: true, value: PollsTypes.RATINGS },
  { id: 3, title: PollsTypes.FREEFOR_TEXT_FIELD, disabled: true, value: PollsTypes.FREEFOR_TEXT_FIELD },
  { id: 4, title: PollsTypes.MULTIPLE_SELECT, disabled: true, value: PollsTypes.MULTIPLE_SELECT },
];

export const presenterVisibleOptions: IRadioDropdownOption[] = [
  { id: 1, title: PresenterVisibility.HIDDEN, value: 1 },
  { id: 2, title: PresenterVisibility.VISIBLE, value: 0 },
];

export const defaultPollPropreties = {
  status: getKeyByValue(PollsViewStatuses, PollsViewStatuses.NOT_STARTED) as TPollStatus,
  type: getKeyByValue(PollsTypes, PollsTypes.MULTIPLE_CHOICE) as TPollType,
  hideForPresenter: true,
  isSlideAdded: false,
  countVotes: 0,
  value: '',
  command: '',
  publicAdjustment: 0,
  result_slide_added: false
};

export enum EllipsisMenu {
  EDIT = 'Edit',
  DELETE = 'Delete',
  REOPEN = 'Reopen poll',
  RESET = 'Reset results'
}

export enum PollCommands {
  START_POLL = 'START_POLL',
  STOP_POLL = 'STOP_POLL'
}

export enum PollsTabsOnMobile {
  LIST = 'All Polls',
  DETAILS = 'Poll Details'
}

export enum FullScreenButtonContent {
  OPEN = 'Present in Full Screen',
  EXIT = 'Exit Full Screen'
}

export enum PollResultsSlideContent {
  RESULTS_SLIDE_ADDED = 'Results slide added',
  ADD_RESULT_SLIDE = 'Add Results Slide',
  TYPE_SLIDE = 'slide',
}